import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(public authService: AuthService, public router: Router) {}

  canActivate(): Observable<boolean> {
    return Observable.create((observer: any) => {
      if (!this.authService.isAuthenticated()) {
        if (!this.authService.isTokenExpired('refresh_token')) {
          this.authService.refreshToken().subscribe(
            data => {
              this.authService.setSession(
                data.access_token,
                data.refresh_token
              );
              return observer.next(true);
            },
            () => {
              this.authService.logout();
              return observer.next(false);
            }
          );
        } else {
          this.authService.logout();
          return observer.next(false);
        }
      }
      return observer.next(true);
    });
  }
}
